import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

export default class extends Controller {
  static values = { 
    key: String, 
    type: String,
    currentSort: String, 
    currentDirection: String 
  }
  static targets = ["iconUp", "iconDown"]

  connect() {
    this.updateSortIndicator()
  }

  async sort() {
    const newDirection = this.getNewDirection()
    const params = new URLSearchParams(window.location.search)
    
    params.set('sort', this.keyValue)
    params.set('direction', newDirection) 
    params.delete('page') // Reset to page 1
    
    // Reset all other column headers
    this.resetAllHeaders()
    
    // Update our internal state immediately for better UX
    this.currentSortValue = this.keyValue
    this.currentDirectionValue = newDirection
    this.updateSortIndicator()
    
    const newUrl = `${window.location.pathname}?${params.toString()}`
    
    await get(newUrl, {
      responseKind: 'turbo-stream'
    })
  }
  
  resetAllHeaders() {
    // Find all other sortable column controllers and reset their visual state
    const otherHeaders = document.querySelectorAll('[data-controller*="sortable-column"]')
    otherHeaders.forEach(header => {
      if (header !== this.element) {
        const upIcon = header.querySelector('[data-sortable-column-target="iconUp"]')
        const downIcon = header.querySelector('[data-sortable-column-target="iconDown"]')
        
        if (upIcon && downIcon) {
          upIcon.classList.remove('text-indigo-600')
          upIcon.classList.add('text-gray-400')
          downIcon.classList.remove('text-indigo-600')
          downIcon.classList.add('text-gray-400')
        }
        
        // Reset header styling
        header.classList.remove('text-indigo-600')
        header.classList.add('text-gray-500')
      }
    })
  }

  getNewDirection() {
    if (this.currentSortValue === this.keyValue) {
      return this.currentDirectionValue === 'asc' ? 'desc' : 'asc'
    }
    return 'asc'
  }

  updateSortIndicator() {
    if (this.hasIconUpTarget && this.hasIconDownTarget) {
      const iconUp = this.iconUpTarget
      const iconDown = this.iconDownTarget
      
      // Reset all classes
      iconUp.classList.remove('text-gray-400', 'text-indigo-600')
      iconDown.classList.remove('text-gray-400', 'text-indigo-600')
      
      if (this.currentSortValue === this.keyValue) {
        // This column is currently sorted - show active state
        if (this.currentDirectionValue === 'asc') {
          iconUp.classList.add('text-indigo-600')
          iconDown.classList.add('text-gray-400')
        } else {
          iconUp.classList.add('text-gray-400')
          iconDown.classList.add('text-indigo-600')
        }
        
        // Add active styling to the entire header
        this.element.classList.remove('text-gray-500')
        this.element.classList.add('text-indigo-600')
      } else {
        // This column is not sorted - show default state
        iconUp.classList.add('text-gray-400')
        iconDown.classList.add('text-gray-400')
        
        // Reset header styling
        this.element.classList.remove('text-indigo-600')
        this.element.classList.add('text-gray-500')
      }
    }
  }

  // Update indicator when values change (for Turbo updates)
  currentSortValueChanged() {
    this.updateSortIndicator()
  }

  currentDirectionValueChanged() {
    this.updateSortIndicator()
  }
}